package org.example.zone360.pages.coachDetails.coachSession

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getSessions
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.MenuDropdown
import org.example.zone360.components.SearchBar
import org.example.zone360.components.formatSessionDate
import org.example.zone360.components.formatSessionHoursAmPm
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.models.MenuModel
import org.example.zone360.pages.coachDetails.coachAssistAi.isPaymentActive
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.mediaManagerUtils.AudioManager
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Divider
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.Strings
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Audio

@Composable
fun CoachesSession(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    sessionDataType: SelectedData,
    notificationSessionId: String,
    notificationCategory: String,
    userId: String,
    onSessionTypeChange: (SelectedData) -> Unit,
    onSessionSelect: (GetSessionsData) -> Unit,
    updatedSession: GetSessionsData?,
    onSessionListFetched: (List<GetSessionsData>) -> Unit,
    getCoachInfo: GetSingleCoachData,
    toastMessageCall: (String) -> Unit,
    subscriptionPopup: (Boolean) -> Unit,
    clubExpiryPopup: (Boolean) -> Unit,
    disable: Boolean
) {
    val scope = rememberCoroutineScope()
    var searchText by remember { mutableStateOf("") }
    val getSessions = remember { mutableStateListOf<GetSessionsData>() }
    val sessionSingleData by remember { mutableStateOf(GetSessionsData()) }
    var selectedSession by remember { mutableStateOf<GetSessionsData?>(null) }
    val filteredData = remember { mutableStateListOf<GetSessionsData>() }
    var addSession by remember { mutableStateOf(false) }
    var audioSession by remember { mutableStateOf(false) }
    fun isPaid(status: String): Boolean = status in setOf(Strings.PAID, Strings.SUCCEEDED)

    val isIndependentCoach = getCoachInfo.organization == Strings.INDEPENDENT
    val isCoachPaid = isPaid(getCoachInfo.payment.checkout.status)
    val isCoachUnexpired = isPaymentActive(getCoachInfo.payment.checkout.expiredOn)

    val (isClubPaid, isClubUnexpired) = when {
        // Case 3 → Logged in as Club Admin
        AppGlobal.userData.role == Strings.ADMIN -> {
            isPaid(AppGlobal.userData.payment.checkout.status) to
                    isPaymentActive(AppGlobal.userData.payment.checkout.expiredOn)
        }
        // Case 2 → Logged in as Non-Independent Coach
        !isIndependentCoach -> {
            isPaid(AppGlobal.userData.clubPayment.status) to
                    isPaymentActive(AppGlobal.userData.clubPayment.expiredOn)
        }

        else -> {
            // For independent coach this won’t matter, but set to false to be safe
            false to false
        }
    }


    fun decodeSessionId(id: String) =
        runCatching { decodeURIComponent(id) }.getOrDefault(id)

// Update filteredData whenever getSessions changes
    LaunchedEffect(
        getSessions.size,
        notificationSessionId,
        sessionDataType
    ) {
        if (getSessions.isEmpty()) return@LaunchedEffect

        val decodedNotificationId = decodeSessionId(notificationSessionId)
            .trim()
            .removeSuffix(".aac")


        val notificationSession = if (decodedNotificationId.isNotBlank()) {
            getSessions.firstOrNull {
                it.sessionId
                    .trim()
                    .removeSuffix(".aac") == decodedNotificationId
            }
        } else null

        val filteredByType = getSessions.filter {
            it.sessionType == if (sessionDataType == SelectedData.Training) Strings.TRAINING else Strings.MATCH
        }
        val defaultSession = if (filteredByType.isNotEmpty()) filteredByType.first() else null
        val finalSession = notificationSession ?: defaultSession ?: getSessions.firstOrNull()

        if (finalSession != null && selectedSession?.sessionId != finalSession.sessionId) {
            selectedSession = finalSession
            onSessionSelect(finalSession)
        }
    }

    // Auto-select first session when sessionDataType changes (Training/Matches tab switch)
    LaunchedEffect(sessionDataType, getSessions.size) {
        if (getSessions.isNotEmpty()) {
            // Filter sessions based on selected type
            val filteredByType = getSessions.filter {
                it.sessionType == if (sessionDataType == SelectedData.Training) Strings.TRAINING else Strings.MATCH
            }

            // Select the first session of the current type if available
            if (filteredByType.isNotEmpty()) {
                val firstSession = filteredByType.first()
                if (selectedSession?.sessionId != firstSession.sessionId) {
                    selectedSession = firstSession
                    onSessionSelect(firstSession)
                }
            }
        }
    }

// Update filteredData when searchText changes
    LaunchedEffect(searchText) {
        filteredData.clear()
        filteredData.addAll(
            if (searchText.isEmpty()) getSessions
            else getSessions.filter {sessionData ->
                sessionData.sessionId
                val parts = sessionData.sessionId.removeSuffix(".aac").split("_")
                val sessionName = parts.first()
                sessionName.contains(searchText, ignoreCase = true) }
        )
    }

    LaunchedEffect(updatedSession) {
        if (updatedSession != null) {
            val index = filteredData.indexOfFirst { it.sessionId == updatedSession.sessionId }
            if (index != -1) {
                filteredData[index] = updatedSession
            }
            selectedSession = updatedSession  // ✅ Re-set selection
            onSessionSelect(updatedSession)
        }
    }

// Fetch session data and populate getSessions
    LaunchedEffect(userId) {
        try {
            val getSessionsResponse = getSessions(
                sessionID = sessionSingleData.sessionId,
                userID = userId,
                domainType = "soccer",
                language = "en",
                organization = AppGlobal.userData.organization,
                getAll = true,
                excludeAssessments = true,
                getWithTagged = true,
                seasonID = AppGlobal.selectedSeasonId
            )
            val sortedData = getSessionsResponse.data.sortedByDescending { sessionData ->
                sessionData.sessionDateTime
            }

            getSessions.clear()
            getSessions.addAll(sortedData)
            onSessionListFetched(sortedData)
            // **Ensure filteredData is updated immediately**
            filteredData.clear()
            filteredData.addAll(sortedData)

        }catch (ce: CancellationException){
            throw ce
        }catch (_: Exception){
            debugPrintln("Failed to fetch sessions")
            toastMessageCall("Failed to fetch sessions")
//            showToast(ToastID.ERROR)
        }
    }
    fun refreshSessionList (){
        scope.launch {
            val getSessionsResponse = getSessions(
                sessionID = sessionSingleData.sessionId,
                userID = userId,
                domainType = "soccer",
                language = "en",
                organization = AppGlobal.userData.organization,
                getAll = true,
                excludeAssessments = true,
                getWithTagged = true,
                seasonID = AppGlobal.selectedSeasonId
            )
            val sortedData = getSessionsResponse.data.sortedByDescending { sessionData ->
                sessionData.sessionDateTime
            }

            getSessions.clear()
            getSessions.addAll(sortedData)
            onSessionListFetched(sortedData)
            // **Ensure filteredData is updated immediately**
            filteredData.clear()
            filteredData.addAll(sortedData)

            if (getSessions.isNotEmpty()) {
                val dt = getSessions.filter {
                    it.sessionType == if (sessionDataType.name.lowercase() == "matches") Strings.MATCH else Strings.TRAINING
                }
                if (dt.isNotEmpty()) {
                    onSessionSelect(dt.first())
                    selectedSession = dt.first()
                }
            } else {
                selectedSession = null
                onSessionSelect(GetSessionsData())
            }
        }
    }
    if (addSession){
        AddSession(
            sitePalette = sitePalette,
            breakpoint = breakpoint,
            onDialogDismiss = {addSession = false},
            onSave = {
                addSession = false
                refreshSessionList()
                AppGlobal.refreshCoachProfile = "${getCurrentMilliseconds()}"
                     },
            coachName = "${getCoachInfo.firstName} ${getCoachInfo.lastName}",
            sessionType = sessionDataType.name.lowercase(),
            userId = userId,
            toastMessageCall = toastMessageCall,
            audioSession = audioSession
        )
    }
    Box(
        modifier = Modifier.minHeight(800.px)
            .maxHeight(1600.px)
            .fillMaxWidth()
           .backgroundColor(sitePalette.modalBackgroundColor.rgb).borderRadius(15.px)
            .padding(20.px)

    ) {
        Column(
            modifier = Modifier.fillMaxSize()
        ) {
            Row (Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically){
            SectionTitle("Sessions")
                if (!disable) {
                    Box(
                        modifier = Modifier.onClick { event ->
                            event.stopPropagation()
                        }
                    ) {
                        MenuDropdown(
                            icon = {
                                FaPlus(
                                    modifier = Modifier.color(sitePalette.primary.rgb)
                                        .cursor(Cursor.Pointer),
                                    size = IconSize.LG,
                                )
                            },
                            data = listOf(
                                MenuModel(text = "Add audio session", route = ""),
                                MenuModel(text = "Add video session", route = "")
                            ),
                            width = 1.percent,
                            onSelect = { select ->
                                when {
                                    isIndependentCoach -> {
                                        if (!isCoachPaid) {
                                            subscriptionPopup(true)
                                            return@MenuDropdown
                                        }
                                        if (!isCoachUnexpired) {
                                            subscriptionPopup(true)
                                            return@MenuDropdown

                                        }
                                    }
                                    // Admin OR Non-independent Coach: must rely on club/admin payment
                                    else -> {
                                        if (!isClubPaid) {
                                            clubExpiryPopup(true)
                                            return@MenuDropdown

                                        }
                                        if (!isClubUnexpired) {
                                            clubExpiryPopup(true)
                                            return@MenuDropdown

                                        }
                                    }
                                }
                                if (select == "Add audio session") {
                                    audioSession = true
                                addSession = true
                                }
                                if (select == "Add video session") {
                                    audioSession = false
                                    addSession = true
                                }

                            }
                        )
                    }
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().height(42.px).margin(topBottom = 10.px)
                    .borderRadius(6.px).backgroundColor(sitePalette.lightGrey.rgb)
                    .padding(leftRight = 5.px, topBottom = 4.px).border(
                        width = 1.px, style = LineStyle.Solid, color = Colors.LightGray
                    ), verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth(50.percent).height(34.px).borderRadius(4.px)
                        .padding(leftRight = 12.px, topBottom = 6.px).cursor(Cursor.Pointer)
                        .backgroundColor(if (sessionDataType == SelectedData.Training) Palette.White.rgbLight else Colors.Transparent)
                        .onClick { onSessionTypeChange(SelectedData.Training) }.boxShadow(
                            offsetX = 0.px,
                            offsetY = if (sessionDataType == SelectedData.Training) 2.px else 0.px,
                            blurRadius = if (sessionDataType == SelectedData.Training) 16.px else 0.px,
                            spreadRadius = null,
                            color = sitePalette.boxShadowColor.rgb
                        ), contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Training",
                        textAlign = TextAlign.Center,
                        fontWeight = 500,
                        fontSize = 16.px,
                        isClickable = true
                    )
                }
                Box(
                    modifier = Modifier.fillMaxWidth(50.percent).height(34.px).borderRadius(4.px)
                        .padding(leftRight = 12.px, topBottom = 6.px).cursor(Cursor.Pointer)
                        .backgroundColor(if (sessionDataType != SelectedData.Training) Palette.White.rgbLight else Colors.Transparent)
                        .onClick {
                            onSessionTypeChange(SelectedData.Matches)
                        }.boxShadow(
                            offsetX = 0.px,
                            offsetY = if (sessionDataType == SelectedData.Matches) 2.px else 0.px,
                            blurRadius = if (sessionDataType == SelectedData.Matches) 16.px else 0.px,
                            spreadRadius = null,
                            color = sitePalette.boxShadowColor.rgb
                        ), contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = "Matches",
                        textAlign = TextAlign.Center,
                        fontWeight = 500,
                        fontSize = 16.px,
                        isClickable = true
                    )
                }

            }
            SearchBar(
                placeholder = "Search...",
                id = "session_Searchbar",
                breakpoint = Breakpoint.LG,
                onEnterClick = {},
                onChange = { newSearchText ->
                    searchText = newSearchText
                },
                onClick = {},
                width = 100.percent,
                showClearButton = false,
                height = 48.px,
                borderColor = Colors.Transparent
            )

            Column(
                modifier = Modifier.fillMaxWidth().margin(topBottom = 15.px)
            ) {
                if (filteredData.isNotEmpty()) {
                    filteredData.forEach { session ->
                        CoachAssessmentSession(
                            data = listOf(session),
                            isSelected = session == selectedSession,
                            onClick = {
                                selectedSession = session
                                onSessionSelect(session)
                            },
                            selectedSessionType = sessionDataType,
                            toastMessageCall = toastMessageCall,
                            breakpoint = breakpoint,
                            refreshList = {
                                refreshSessionList()
                            },
                            notificationSessionId = notificationSessionId,
                            notificationCategory = notificationCategory
                        )
                    }
                } else {
                        FieldTitleTextNormalSimple(
                            text = "No Sessions Found",
                            fontSize = 16.px,
                            width = 100.percent,
                            fontWeight = 500,
                            textAlign = TextAlign.Center
                        )
                }
            }
        }
    }
}


@Composable
fun CoachAssessmentSession(
    data: List<GetSessionsData>,
    isSelected: Boolean,
    onClick: () -> Unit,
    notificationSessionId: String,
    notificationCategory: String,
    selectedSessionType: SelectedData,
    toastMessageCall: (String) -> Unit,
    breakpoint: Breakpoint,
    refreshList : () -> Unit

) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var currentlyPlayingId by remember { mutableStateOf<String?>(null) }
    var loadingSessionId by remember { mutableStateOf<String?>(null) }
    val currentAudioRef = remember { mutableStateOf<Audio?>(null) }
    var deleteSession by remember { mutableStateOf(false) }
    var sessionID by remember { mutableStateOf("") }


    data.forEach { sessionData ->
        val filterData = when (selectedSessionType) {
            SelectedData.Training -> sessionData.sessionType == Strings.TRAINING
            SelectedData.Matches -> sessionData.sessionType == Strings.MATCH
        }

        if (filterData && sessionData.organization == AppGlobal.userData.organization) {
            val parts = sessionData.sessionId.removeSuffix(".aac").split("_")
            val sessionName = parts.first()

            val isAudioAllowed =
                sessionData.category != "customVideo" && sessionData.sessionId.isNotBlank()


            val audioUrl = "${Res.Audio.audio_base_url}${sessionData.sessionId}"
            val audio = remember(sessionData.sessionId) { mutableStateOf<Audio?>(null) }

            LaunchedEffect(isSelected) {
                if (isSelected && isAudioAllowed) {
                    audio.value = AudioManager.prepare(audioUrl)
                } else if (!isSelected) {
                    AudioManager.suspendDownload(audioUrl)
                    audio.value = null
                }
            }


            var audioProgress by remember { mutableStateOf(0f) }

            if (isAudioAllowed) {
                DisposableEffect(Unit) {
                    onDispose {
                        if (currentlyPlayingId == sessionData.sessionId) {
                            audio.value?.pause()
                            currentlyPlayingId = null
                            audioProgress = 0f
                        }
                    }
                }

                LaunchedEffect(currentlyPlayingId) {
                    if (currentlyPlayingId != null) {
                        val audioPlay = currentAudioRef.value
                        audioPlay?.apply {
                            while (currentTime < duration) {
                                audioProgress = (currentTime / duration).toFloat()
                                delay(100)
                            }
                        }
                    }
                }
            }
            if (deleteSession){
                DeleteSession(
                    onDialogDismiss =  {deleteSession = false},
                    toastMessage = toastMessageCall,
                    sessionId = sessionID,
                    onSaveChanges = {
                        AppGlobal.refreshCoachProfile = "${getCurrentMilliseconds()}"
                        
                        refreshList()
                        deleteSession = false
                        AudioManager.release("${Res.Audio.audio_base_url}${sessionID}")

                                    },
                    breakpoint = breakpoint
                )
            }

            Box(
                modifier = Modifier.fillMaxWidth().borderRadius(8.px)
                    .backgroundColor(if (isSelected) sitePalette.selectedSessionBackground.rgb else Colors.Transparent)
                    .padding(topBottom = 12.px, leftRight = 8.px).onClick {
                        onClick()
                    }.border(
                        2.px,
                        style = LineStyle.Solid,
                        color = if (isSelected) sitePalette.primary.rgb else Colors.Transparent
                    )
            ) {

                Column(
                    modifier = Modifier.fillMaxSize().gap(10.px)
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        val lang = mapLanguageToPrefix(sessionData.language)
                        FieldTitleTextNormalSimple(
                            text = sessionName.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                            fontSize = 16.px,
                            wordBreak = WordBreak.BreakAll,
                            fontWeight = 500
                        )
                        if (sessionData.status != Strings.COMPLETED) {
                            CustomSpacer(15.px)
                            Image(
                                src = Res.Images.loading_gif,
                                alt = "Loading",
                                modifier = Modifier.size(32.px)
                            )
                        }
                        CustomSpacer(15.px)
                        if (sessionData.role == Strings.TAGGED) {
                            Image(src = Res.Images.tag_Icon, modifier = Modifier.size(15.px))
                            FieldTitleTextNormalSimple(
                                text = sessionData.coachName.replaceFirstChar {
                                    if (it.isLowerCase()) it.titlecase() else it.toString()
                                },
                                fontSize = 14.px,
                                fontWeight = 400,
                                wordBreak = WordBreak.BreakAll,
                                fontFamily = Constants.IBM_FONT,
                                marginLeft = 5.px
                            )
                        }
                        Spacer()
                        FieldTitleTextNormalSimple(
                            text = "($lang)",
                            fontSize = 14.px,
                            fontWeight = 500,
                            marginRight = 8.px
                        )
                        Box(
                            modifier = Modifier
//                                .onClick { event -> event.nativeEvent.stopPropagation() }
                                .styleModifier { property("position", "relative") }
                        ) {
                            MenuDropdown(
                                icon = {
                                    FaEllipsisVertical(
                                        modifier = Modifier.color(Palette.Black.rgbLight)
                                    )
                                },
                                data = listOf(
                                    MenuModel(text = "Delete", route = "")
                                ),
                                width = 1.percent,
                                onSelect = { select ->
                                    if (select == "Delete") {
                                        sessionID = sessionData.sessionId
                                        deleteSession = true
                                    }
                                }
                            )
                        }
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {

                        Row(
                            modifier = Modifier.width(70.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.timeCircle, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                sessionData.recordTime.toLongOrNull()?.let {
                                    (it / 1000).formatSessionMinutes()
                                } ?: "-", marginRight = 3.px
                            )
                        }

                        Row(
                            modifier = Modifier.width(200.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(src = Res.Images.calender, modifier = Modifier.size(17.px))
                            CustomSpacer(5.px)
                            FieldTitleTextNormalSimple(
                                "${sessionData.sessionDateTime.formatSessionDate()}, ${sessionData.sessionDateTime.formatSessionHoursAmPm()}"
                            )
                        }
                    }


                    if (!isSelected) {
                        Divider()
                    }
                }
            }
        }
    }
}


fun mapLanguageToPrefix(lang: String): String {
    return when (lang.lowercase()) {
        "en" -> "EN"
        "es" -> "ES"
        "fr" -> "FR"
        "it" -> "IT"
        else -> lang.uppercase()
    }
}

external fun decodeURIComponent(encodedURI: String): String